import styles from "./IntroTeacher.module.less";
import { useState } from "react";
import CommonNavBar from "views/components/CommonNavBar";
import { useNavigate } from "react-router-dom";

const IntroTeacher = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(3);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div className={styles["step-1"]}>
            <div className={styles["step-1-title"]}>学员的英文名是？</div>
            <input
              className={styles["step-1-input"]}
              placeholder="请输入学员的英文名"
            />
            <img
              className={styles["step-1-button"]}
              src={require("@/images/intro-teacher/start-phone.png")}
              onClick={() => setStep(2)}
            />
          </div>
        );
      case 2:
        return (
          <div className={styles["step-2"]}>
            <div className={styles["step-2-title"]}>学员现在几岁了</div>
            <input
              className={styles["step-1-input"]}
              placeholder="请选择学员的年龄"
              readOnly
            />
          </div>
        );
      case 3:
        return (
          <div className={styles["step-3"]}>
            <div className={styles["step-3-title"]}>学员当前的口语能力是？</div>
            <div className={styles["step-3-content"]}>
              <div className={styles["step-3-content-item"]}>
                <img className={styles["item-img"]} />
                <div className={styles["item-text"]}>
                  能拼读姓名、电话能拼读姓名、电话、邮箱等个人基础信息；听能拼读姓名、电话、邮箱等个人基础信息；听
                </div>
              </div>
              <div className={styles["step-3-content-item"]}></div>
              <div className={styles["step-3-content-item"]}></div>
            </div>
          </div>
        );
      case 4:
        return (
          <div className={styles["step-4"]}>
            <div className={styles["step-4-title"]}>
              以下哪套读物学员正在阅读？
            </div>
            <div className={styles["step-4-content"]}>
              <div className={styles["step-4-content-item"]}>
                <div className={styles["item-text"]}>牛津树</div>
              </div>
              <div className={styles["step-4-content-item"]}>
                <div className={styles["item-text"]}>牛津树</div>
              </div>
              <div className={styles["step-4-content-item"]}>
                <div className={styles["item-text"]}>牛津树</div>
              </div>
              <div className={styles["step-4-content-item"]}>
                <div className={styles["item-text"]}>牛津树</div>
              </div>
              <div className={styles["step-4-content-item"]}>
                <div className={styles["item-text"]}>牛津树</div>
              </div>
              <div className={styles["step-4-content-item"]}>
                <div className={styles["item-text"]}>牛津树</div>
              </div>
              <div className={styles["step-4-content-item"]}>
                <div className={styles["item-text"]}>牛津树</div>
              </div>
              <div className={styles["step-4-content-item"]}>
                <div className={styles["item-text"]}>牛津树</div>
              </div>
            </div>
          </div>
        );
      default:
        return <div>Step {step}</div>;
    }
  };

  return (
    <div className={styles["intro-teacher-container"]}>
      <CommonNavBar
        backgroundColor={"transparent"}
        onClickBack={() => {
          navigate(-1);
        }}
      />
      <div className={styles["header"]}>
        <div className={styles["header-progress"]}></div>
        <img
          className={styles["header-icon"]}
          src={require("@/images/intro-teacher/title-phone.png")}
        />
      </div>
      {renderStep()}
      <div className={styles["footer"]}>
        <div className={styles["footer-last-button"]}>上一题</div>
      </div>
    </div>
  );
};

export default IntroTeacher;
